import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialImportHistoryState } from './initialState'
import { ImportHistoryEntry } from './types'

const slice = createSlice({
  name: 'userLists/importHistory',
  initialState: initialImportHistoryState,
  reducers: {
    setImportHistory: (
      state,
      action: PayloadAction<{
        userListId: number
        entries: ImportHistoryEntry[]
      }>
    ) => {
      const { userListId, entries } = action.payload
      state.entries[userListId] = entries
    },
  },
})

export const reducer = slice.reducer
export const { setImportHistory } = slice.actions

type UserListsRootState = {
  userLists: { importHistory: ReturnType<typeof reducer> }
}

export const selectImportHistoryByListId = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.importHistory.entries[userListId] || []

export const selectImportHistoryPagination = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.importHistory.pagination[userListId] || null

export type {
  ImportHistoryEntry,
  ImportHistoryState,
  ImportStatus,
} from './types'
